/**
 * Centralized runtime configuration sourced from environment variables.
 * Use CRA `REACT_APP_` prefix for local development and CI build-time values.
 * Provides sensible fallbacks so the app behaves the same when env vars are missing.
 */

export const RPC_URL: string = process.env.REACT_APP_RPC_URL ?? 'https://rpc.h2chain.io';
export const CHAIN_ID: string = process.env.REACT_APP_CHAIN_ID ?? '2582';
export const EXPLORER_URL: string = process.env.REACT_APP_EXPLORER_URL ?? 'https://h2scan.io';
export const EXTENSION_URL: string =
  process.env.REACT_APP_EXTENSION_URL ??
  'https://chromewebstore.google.com/detail/h2-wallet/efoempndpndipldoiefpinclpgfbbbek?authuser=0&hl=zh-CN';
// Community / support URL
export const COMMUNITY_URL: string = process.env.REACT_APP_COMMUNITY_URL ?? 'https://community.h2chain.io';

export const PRODUCT_LINKS: Readonly<{
  H2SWAP: string;
  H2BRIDGE: string;
  H2STAKE: string;
}> = Object.freeze({
  H2SWAP: process.env.REACT_APP_PRODUCT_LINK_H2SWAP ?? 'https://h2swap.org',
  H2BRIDGE: process.env.REACT_APP_PRODUCT_LINK_H2BRIDGE ?? 'https://h2bridge.net',
  H2STAKE: process.env.REACT_APP_PRODUCT_LINK_H2STAKE ?? 'https://stake.h2chain.io',
});

// Optional helper
export const isExternal = (url: string) => /^https?:\/\//.test(url);
